import {StyleSheet} from 'react-native';
import Spacing from './Spacing';

export default StyleSheet.create({
  row: {
    flexDirection: 'row',
  },
  col: {
    flexDirection: 'column',
  },

  flex1: {
    flex: 1,
  },
  flex2: {
    flex: 2,
  },
  flex3: {
    flex: 3,
  },
  flexGrow1: {
    flexGrow: 1,
  },
  flexGrow2: {
    flexGrow: 2,
  },
  flexGrow3: {
    flexGrow: 3,
  },

  pagePadding: {
    paddingHorizontal: Spacing.pagePadding,
  },
  pagePaddingVertical: {
    paddingVertical: Spacing.pagePadding,
  },

  alignCenter: {
    alignItems: 'center',
  },
  justifyCenter: {
    justifyContent: 'center',
  },
  center: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});
